(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-latest-tip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const swiperElement = document.querySelector('.tf-swiper');
    if (swiperElement) {
      const swiperConfig = JSON.parse(swiperElement.getAttribute('data-swiper'));
      new Swiper(swiperElement, swiperConfig);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-banner"] && !Shopify.designMode) return;
  try {
    

// Global cookie functions
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
}

// Initialize cookie banner when DOM is ready
function initCookieBanner() {
  const banner = document.querySelector('.sys-cookies');
  if (!banner) {
    console.log('No cookie banner found');
    return;
  }
    
  // Check if we're in theme customizer mode
  const isThemeCustomizer = window.Shopify && window.Shopify.designMode;
  
  if (isThemeCustomizer) {
    // Get section ID from data attribute
    const sectionId = banner.getAttribute('data-section-id');
    
    // Handle theme customizer section selection
    document.addEventListener('shopify:section:select', function(event) {
      if (event.detail.sectionId === sectionId) {
        // Show banner when this section is selected
        banner.style.display = 'block';
      }
    });

    // Listen for section deselection events
    document.addEventListener('shopify:section:deselect', function(event) {
      if (event.detail.sectionId === sectionId) {
        // Hide banner when this section is deselected
        banner.style.display = 'none';
      }
    });

    // Initially hide the banner in customizer mode
    banner.style.display = 'none';
    console.log('Cookie banner hidden initially in theme customizer mode');
  } else {
    // Check if cookie banner should be shown (not in customizer)
    const cookieConsent = getCookie('theme4:cookies');
    if (cookieConsent) {
      banner.style.display = 'none';
      return;
    } else {
      banner.style.display = 'block';
    }
  }
  
  const acceptBtn = banner.querySelector('#accept-cookie');
  const declineBtn = banner.querySelector('#decline-cookie');
  
  console.log('Accept button:', acceptBtn);
  console.log('Decline button:', declineBtn);
  
  if (acceptBtn) {
    acceptBtn.addEventListener('click', function() {
      console.log('Accept button clicked via direct listener');
      handleAccept();
    });
  }
  
  if (declineBtn) {
    declineBtn.addEventListener('click', function() {
      console.log('Decline button clicked via direct listener');
      handleDecline();
    });
  }
  
  // Also add event delegation
  banner.addEventListener('click', function(event) {
    console.log('Click event on banner:', event.target);
    if (event.target.id === 'accept-cookie' || event.target.classList.contains('hdt-pp_cookies__accept-btn')) {
      console.log('Accept clicked via delegation');
      handleAccept();
    } else if (event.target.id === 'decline-cookie' || event.target.classList.contains('hdt-pp_cookies__decline-btn')) {
      console.log('Decline clicked via delegation');
      handleDecline();
    }
  });
}

function handleAccept() {
  console.log('Accept button clicked');
  const banner = document.querySelector('.sys-cookies');
  const isThemeCustomizer = window.Shopify && window.Shopify.designMode;
  
  if (banner && !isThemeCustomizer) {
    banner.style.display = 'none';
  }
  
  // Only set cookie if not in theme customizer
  if (!isThemeCustomizer) {
    const configs = JSON.parse(banner.getAttribute('data-configs') || '{}');
    setCookie('theme4:cookies', 'accepted', parseInt(configs.day_next || 30));
    
    // Set tracking consent if Shopify API is available
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(true);
      } catch (error) {
        console.error('Error setting tracking consent:', error);
      }
    }
  }
}

function handleDecline() {
  console.log('Decline button clicked');
  const banner = document.querySelector('.sys-cookies');
  const isThemeCustomizer = window.Shopify && window.Shopify.designMode;
  
  if (banner && !isThemeCustomizer) {
    banner.style.display = 'none';
  }
  
  // Only set cookie if not in theme customizer
  if (!isThemeCustomizer) {
    const configs = JSON.parse(banner.getAttribute('data-configs') || '{}');
    setCookie('theme4:cookies', 'declined', parseInt(configs.day_next || 30));
    
    // Set tracking consent if Shopify API is available
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(false);
      } catch (error) {
        console.error('Error setting tracking consent:', error);
      }
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCookieBanner);
} else {
  initCookieBanner();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  // Initialize province/state selectors
  document.addEventListener('DOMContentLoaded', function() {
    // Handle add new address form
    const addAddressBtn = document.querySelector('.btn-add-address');
    const addAddressForm = document.getElementById('form-add-address');
    const hideAddressBtn = document.querySelector('.btn-hide-address');
    const submitAddAddressBtn = document.getElementById('submit-add-address');

    // Show form if there are server-side errors
    if (addAddressForm && addAddressForm.querySelector('.form-errors')) {
      addAddressForm.style.display = 'block';
    }

    if (addAddressBtn && addAddressForm) {
      addAddressBtn.addEventListener('click', function(e) {
        e.preventDefault();
        addAddressForm.style.display = 'block';
        // Clear any previous error messages
        clearAllErrors();
      });
    }

    if (hideAddressBtn && addAddressForm) {
      hideAddressBtn.addEventListener('click', function(e) {
        e.preventDefault();
        addAddressForm.style.display = 'none';
        clearAllErrors();
      });
    }

    // Handle form submission with validation
    if (addAddressForm) {
      const actualForm = addAddressForm.querySelector('form');
      const submitBtn = document.getElementById('submit-add-address');
      
      if (actualForm) {
        actualForm.addEventListener('submit', function(e) {
          console.log('Form submit event triggered');
          // Clear previous errors
          clearAllErrors();
          
          // Validate form
          const isValid = validateAddAddressForm();
          console.log('Form validation result:', isValid);
          
          if (!isValid) {
            console.log('Preventing form submission due to validation errors');
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        });
      }
      
      // Also handle button click as backup
      if (submitBtn) {
        submitBtn.addEventListener('click', function(e) {
          console.log('Submit button clicked');
          // Clear previous errors
          clearAllErrors();
          
          // Validate form
          const isValid = validateAddAddressForm();
          console.log('Button validation result:', isValid);
          
          if (!isValid) {
            console.log('Preventing button submission due to validation errors');
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        });
      }
    }

    // Handle edit address forms
    const editAddressBtns = document.querySelectorAll('.btn-edit-address');
    const hideEditAddressBtns = document.querySelectorAll('.btn-hide-edit-address');

    editAddressBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const formId = this.getAttribute('data-form');
        const form = document.getElementById(formId);
        if (form) {
          form.style.display = 'block';
        }
      });
    });

    hideEditAddressBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const form = this.closest('.edit-form-address');
        if (form) {
          form.style.display = 'none';
        }
      });
    });

    // Validation functions
    function validateAddAddressForm() {
      let isValid = true;
      let errorCount = 0;
      
      // Required fields validation
      const requiredFields = [
        { id: 'AddressFirstNameNew', errorId: 'error-firstname', name: 'First Name' },
        { id: 'AddressLastNameNew', errorId: 'error-lastname', name: 'Last Name' },
        { id: 'Address1New', errorId: 'error-address1', name: 'Address' },
        { id: 'AddressCityNew', errorId: 'error-city', name: 'City' },
        { id: 'AddressCountryNew', errorId: 'error-country', name: 'Country' }
      ];

      requiredFields.forEach(function(field) {
        const input = document.getElementById(field.id);
        const errorDiv = document.getElementById(field.errorId);
        
        if (!input.value.trim()) {
          showError(field.errorId, field.name + ' is required');
          isValid = false;
          errorCount++;
        } else {
          hideError(field.errorId);
        }
      });

      // Phone number validation (optional but if provided, validate format)
      const phoneInput = document.getElementById('AddressPhoneNew');
      const phoneErrorDiv = document.getElementById('error-phone');
      
      if (phoneInput.value.trim()) {
        const phoneRegex = /^[\+]?[1-9][\d]{0,15}$/;
        if (!phoneRegex.test(phoneInput.value.trim().replace(/[\s\-\(\)]/g, ''))) {
          showError('error-phone', 'Please enter a valid phone number');
          isValid = false;
          errorCount++;
        } else {
          hideError('error-phone');
        }
      }

      // Postal code validation (numbers only and required)
      const zipInput = document.getElementById('AddressZipNew');
      console.log('Postal code value:', zipInput.value);
      console.log('Postal code trimmed:', zipInput.value.trim());
      
      if (!zipInput.value.trim()) {
        console.log('Postal code is empty');
        showError('error-zip', 'Postal code is required');
        isValid = false;
        errorCount++;
      } else {
        const zipRegex = /^\d+$/;
        const zipValue = zipInput.value.trim();
        const isZipValid = zipRegex.test(zipValue);
        console.log('Postal code regex test result:', isZipValid);
        
        if (!isZipValid) {
          console.log('Postal code contains non-numbers');
          showError('error-zip', 'Postal code must contain only numbers');
          isValid = false;
          errorCount++;
        } else {
          console.log('Postal code is valid');
          hideError('error-zip');
        }
      }

      // Show general error message if there are multiple errors
      if (!isValid && errorCount > 1) {
        showGeneralError('Please correct the errors highlighted below before submitting.');
      }

      return isValid;
    }

    function showError(errorId, message) {
      const errorDiv = document.getElementById(errorId);
      if (errorDiv) {
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
        
        // Add error styling to input
        const inputId = errorId.replace('error-', 'Address');
        const input = document.getElementById(inputId);
        if (input) {
          input.style.borderColor = '#dc3545';
          
          // Add error class to select container if it's a select
          const selectContainer = input.closest('.select');
          if (selectContainer) {
            selectContainer.classList.add('has-error');
            selectContainer.classList.remove('has-success');
          }
        }
      }
    }

    function hideError(errorId) {
      const errorDiv = document.getElementById(errorId);
      if (errorDiv) {
        errorDiv.style.display = 'none';
        
        // Remove error styling from input
        const inputId = errorId.replace('error-', 'Address');
        const input = document.getElementById(inputId);
        if (input) {
          input.style.borderColor = '';
          
          // Remove error class from select container if it's a select
          const selectContainer = input.closest('.select');
          if (selectContainer) {
            selectContainer.classList.remove('has-error');
            selectContainer.classList.remove('has-success');
          }
        }
      }
    }

    function clearAllErrors() {
      const errorDivs = document.querySelectorAll('.error-message');
      errorDivs.forEach(function(errorDiv) {
        errorDiv.style.display = 'none';
      });
      
      // Clear general error
      const generalError = document.getElementById('general-error');
      if (generalError) {
        generalError.style.display = 'none';
      }
      
      // Clear error styling from all inputs
      const inputs = addAddressForm.querySelectorAll('input');
      inputs.forEach(function(input) {
        input.style.borderColor = '';
      });
    }

    function showGeneralError(message) {
      const generalError = document.getElementById('general-error');
      const generalErrorText = document.getElementById('general-error-text');
      if (generalError && generalErrorText) {
        generalErrorText.textContent = message;
        generalError.style.display = 'block';
      }
    }

    // Real-time validation on input change
    const addAddressInputs = addAddressForm.querySelectorAll('input[required]');
    addAddressInputs.forEach(function(input) {
      input.addEventListener('blur', function() {
        const fieldName = this.id.replace('Address', '').replace('New', '');
        const errorId = 'error-' + fieldName.toLowerCase();
        
        if (!this.value.trim()) {
          showError(errorId, this.previousElementSibling.textContent + ' is required');
        } else {
          hideError(errorId);
        }
      });
    });

    // Setup country/province selectors using Shopify's built-in CountryProvinceSelector
    function setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        // Setup for new address form
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        });
      }
    }

    // Initialize country/province selectors
    setupCountries();

    // Address pagination variables
    let currentAddressPage = 1;
    const addressesPerPage = 2;
    const addressesList = document.getElementById('addressesList');
    const addressPaginationContainer = document.getElementById('addressPaginationContainer');
    const addressPagination = document.getElementById('addressPagination');
    const addressItems = addressesList ? addressesList.querySelectorAll('.account-address-item') : [];
    const totalAddressPages = Math.ceil(addressItems.length / addressesPerPage);

    // Initialize address pagination
    if (addressItems.length > addressesPerPage) {
      displayAddressesWithPagination();
      updateAddressPagination();
    }

    // Handle validation for country and province selects
    const countrySelect = document.getElementById('AddressCountryNew');
    const provinceSelect = document.getElementById('AddressProvinceNew');
    
    if (countrySelect) {
      countrySelect.addEventListener('change', function() {
        const errorId = 'error-country';
        if (!this.value) {
          showError(errorId, 'Country is required');
        } else {
          hideError(errorId);
        }
      });
    }

    // Address pagination functions
    function displayAddressesWithPagination() {
      const startIndex = (currentAddressPage - 1) * addressesPerPage;
      const endIndex = startIndex + addressesPerPage - 1;

      addressItems.forEach((item, index) => {
        if (index >= startIndex && index <= endIndex) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    }

    function updateAddressPagination() {
      if (totalAddressPages <= 1) {
        addressPaginationContainer.style.display = 'none';
        return;
      }
      
      addressPaginationContainer.style.display = 'block';
      
      let paginationHTML = '';
      
      // Previous button
      if (currentAddressPage > 1) {
        paginationHTML += `
          <li>
            <a href="#" class="pagination-item" data-page="${currentAddressPage - 1}">
              <i class="icon-arr-left"></i>
            </a>
          </li>
        `;
      }
      
      // Page numbers
      const maxVisiblePages = 5;
      let startPage = Math.max(1, currentAddressPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(totalAddressPages, startPage + maxVisiblePages - 1);
      
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
      
      for (let i = startPage; i <= endPage; i++) {
        if (i === currentAddressPage) {
          paginationHTML += `
            <li class="active">
              <div class="pagination-item">${i}</div>
            </li>
          `;
        } else {
          paginationHTML += `
            <li>
              <a href="#" class="pagination-item" data-page="${i}">${i}</a>
            </li>
          `;
        }
      }
      
      // Next button
      if (currentAddressPage < totalAddressPages) {
        paginationHTML += `
          <li>
            <a href="#" class="pagination-item" data-page="${currentAddressPage + 1}">
              <i class="icon-arr-right2"></i>
            </a>
          </li>
        `;
      }
      
      addressPagination.innerHTML = paginationHTML;
      
      // Add click event listeners to pagination
      addressPagination.querySelectorAll('[data-page]').forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const page = parseInt(this.dataset.page);
          if (page !== currentAddressPage) {
            currentAddressPage = page;
            displayAddressesWithPagination();
            updateAddressPagination();
            // Scroll to top of addresses list
            addressesList.scrollIntoView({ behavior: 'smooth' });
          }
        });
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-sellers"] && !Shopify.designMode) return;
  try {
    
  // Initialize tabs
  document.addEventListener('DOMContentLoaded', function() {
    // The card-product snippet handles all the product interactions
    // No need for additional JavaScript here
  });

  } catch(e) { console.error(e); }
})();
})();
